import Vue from 'vue'
import router from './router';
import vuetify from './plugins/vuetify';
import App from './App.vue'
import i18n from "./i18n";

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App),
  // component: { App }
}).$mount('#app')
